import { cn } from "@/lib/utils";
import type { AspectRatioIconProps } from "./types";

export function AspectRatioIcon({ type, className }: AspectRatioIconProps) {
  const baseClass = "border border-current rounded-[2px] flex-shrink-0";

  switch (type) {
    case "ultra-wide":
      return <div className={cn(baseClass, "w-6 h-2.5", className)} />;
    case "wide":
      return <div className={cn(baseClass, "w-5 h-3", className)} />;
    case "standard":
      return <div className={cn(baseClass, "w-4 h-3", className)} />;
    case "photo":
      // 3:2 ratio - fixed proportions
      return <div className={cn(baseClass, className)} style={{ width: "18px", height: "12px" }} />;
    case "square":
      return <div className={cn(baseClass, "w-4 h-4", className)} />;
    case "portrait":
      // 9:16 ratio - fixed proportions
      return <div className={cn(baseClass, className)} style={{ width: "9px", height: "16px" }} />;
    case "portrait-standard":
      return <div className={cn(baseClass, "w-3 h-4", className)} />;
    case "portrait-photo":
      // 2:3 ratio - fixed proportions
      return <div className={cn(baseClass, className)} style={{ width: "10px", height: "15px" }} />;
    case "landscape-compact":
      return <div className={cn(baseClass, "w-4 h-3.5", className)} />;
    case "portrait-compact":
      return <div className={cn(baseClass, "w-3.5 h-4", className)} />;
    default:
      return <div className={cn(baseClass, "w-4 h-4", className)} />;
  }
}
